// extracted by mini-css-extract-plugin
export var sliderRange = "_l4-2";
export var sliderRoot = "_l4-0";
export var sliderThumb = "_l4-3";
export var sliderTrack = "_l4-1";